// ** React Imports
import React, { Fragment, useState, useRef, useEffect } from "react";
import Modal from "react-modal";
// ** Third Party Components
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";
// ** Vertical Menu Components
import VerticalMenuHeader from "./VerticalMenuHeader";
import VerticalNavMenuItems from "./VerticalNavMenuItems";
import "../../../../assets/navItems.css";
import vector from "../../../../assets/img/vector.png";
import Repository from "../../../../../configs/axios/repository";
import { handleShowMenu } from "../../../../../redux/layout";
import {
    handleInvate,
    handleRole,
    handleCourseShow,
} from "../../../../../redux/layout";
import settings from "@src/assets/icons/settings.svg";
import notifications from "@src/assets/icons/notifications.png";
import premium from "@src/assets/icons/Premium.svg";
import logout from "@src/assets/icons/logout.svg";
import refresh from "@src/assets/icons/refresh.svg";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const Sidebar = (props) => {
    // ** Props
    const {
        menuCollapsed,
        routerProps,
        menu,
        currentActiveItem,
        skin,
        menuData,
    } = props;

    // ** States
    const dispatch = useDispatch();

    const [groupOpen, setGroupOpen] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showBtn, setShowBtn] = useState(false);
    const [isInvate, setIsInvate] = useState(false);
    const [role, setRole] = useState("");
    const [isInstructor, setIsInstructor] = useState(false);
    const [groupActive, setGroupActive] = useState([]);
    const [currentActiveGroup, setCurrentActiveGroup] = useState([]);
    const [activeItem, setActiveItem] = useState(null);
    const courseShow = useSelector((state) => state.layout.courseShow);

    const shadowRef = useRef(null);
    let planState = localStorage.getItem("planState");
    // ** Menu Hover State
    const [menuHover, setMenuHover] = useState(false);
    // const [subscriptionUrl, setSubscriptionUrl] = useState("");
    // ** Ref

    // ** Function to handle Mouse Enter
    const onMouseEnter = () => {
        setMenuHover(true);
    };

    // ** Scroll Menu
    const scrollMenu = (container) => {
        if (shadowRef && container.scrollTop > 0) {
            if (!shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.add("d-block");
            }
        } else {
            if (shadowRef.current.classList.contains("d-block")) {
                shadowRef.current.classList.remove("d-block");
            }
        }
    };
    const findThisUserData = async () => {
        setLoading(false);
        const result = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );

        if (result.data?.success === true) {
            setIsInstructor(result.data.data.is_verified_instructor);
            setIsInvate(result.data.data.is_invate);
            dispatch(handleInvate(result.data.data.is_invate));
            dispatch(handleRole(result.data.data.user_role[0]?.role_id.name));
            dispatch(handleCourseShow(false));
            setRole(result.data.data.user_role[0]?.role_id.name);
            if (
                result.data.data.plan_state == "active" ||
                result.data.data.plan_state == "trialing"
            ) {
                localStorage.setItem("planState", "active");
                setShowBtn(false);
            } else {
                localStorage.setItem("planState", result.data.data.plan_state);
                setShowBtn(true);
            }
            setLoading(true);
        }
        setLoading(true);
    };

    useEffect(() => {
        findThisUserData();
    }, [planState]);

    useEffect(() => {
        if (courseShow == true || courseShow == "true") {
            findThisUserData();
        }
    }, [handleShowMenu, courseShow]);

    useEffect(async () => {
        if (
            planState == "active" ||
            planState == "trialing" ||
            planState == "plan_state"
        ) {
            setShowBtn(false);
        } else {
            setShowBtn(true);
        }
    }, []);
    return loading ? (
        <Fragment>
            <div
                onClick={() => {
                    dispatch(handleShowMenu(false));
                }}
                id="menuDiv"
                className={classnames(
                    "main-menu menu-fixed menu-accordion menu-shadow",
                    {
                        // expanded: menuHover || menuCollapsed === false,
                        "menu-light": skin !== "semi-dark" && skin !== "dark",
                        "menu-dark": skin === "semi-dark" || skin === "dark",
                    }
                )}
                onMouseEnter={onMouseEnter}
                onMouseLeave={() => setMenuHover(false)}
            >
                {menu ? (
                    menu
                ) : (
                    <div>
                        <Fragment>
                            <VerticalMenuHeader
                                setGroupOpen={setGroupOpen}
                                menuHover={menuHover}
                                {...props}
                            />
                            {/* Vertical Menu Header Shadow */}
                            <div
                                className="shadow-bottom"
                                ref={shadowRef}
                            ></div>
                            {/* Perfect Scrollbar */}

                            <PerfectScrollbar
                                id="scrollbarId"
                                className="main-menu-content fragmentBottom"
                                options={{ wheelPropagation: false }}
                                onScrollY={(container) => scrollMenu(container)}
                            >
                                <ul
                                    className="navigation navigation-main"
                                    style={{ height: "100%" }}
                                >
                                    <VerticalNavMenuItems
                                        items={menuData}
                                        role={role}
                                        isInvate={isInvate}
                                        menuData={menuData}
                                        menuHover={menuHover}
                                        groupOpen={groupOpen}
                                        activeItem={activeItem}
                                        groupActive={groupActive}
                                        currentActiveGroup={currentActiveGroup}
                                        routerProps={routerProps}
                                        setGroupOpen={setGroupOpen}
                                        menuCollapsed={menuCollapsed}
                                        setActiveItem={setActiveItem}
                                        setGroupActive={setGroupActive}
                                        setCurrentActiveGroup={
                                            setCurrentActiveGroup
                                        }
                                        currentActiveItem={currentActiveItem}
                                    />
                                </ul>

                                {role != "instructor" ? (
                                    showBtn ? (
                                        <ul className="navigation navigation-main">
                                            <VerticalNavMenuItems
                                                items={[
                                                    {
                                                        id: "subscription",
                                                        title: "Premium",
                                                        icon: (
                                                            <img
                                                                src={premium}
                                                                style={{
                                                                    marginRight:
                                                                        "15px",
                                                                }}
                                                                alt="dff"
                                                            />
                                                        ),
                                                        navLink:
                                                            "/subscription",
                                                    },
                                                ]}
                                                menuData={[
                                                    {
                                                        id: "subscription",
                                                        title: "Premium",
                                                        icon: (
                                                            <img
                                                                src={settings}
                                                                style={{
                                                                    marginRight:
                                                                        "15px",
                                                                }}
                                                                alt="dff"
                                                            />
                                                        ),
                                                        navLink:
                                                            "/subscription",
                                                    },
                                                ]}
                                                menuHover={menuHover}
                                                isInvate={isInvate}
                                                groupOpen={groupOpen}
                                                activeItem={activeItem}
                                                groupActive={groupActive}
                                                currentActiveGroup={
                                                    currentActiveGroup
                                                }
                                                routerProps={routerProps}
                                                setGroupOpen={setGroupOpen}
                                                menuCollapsed={menuCollapsed}
                                                setActiveItem={setActiveItem}
                                                setGroupActive={setGroupActive}
                                                setCurrentActiveGroup={
                                                    setCurrentActiveGroup
                                                }
                                                currentActiveItem={
                                                    currentActiveItem
                                                }
                                            />
                                        </ul>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                )}
                            </PerfectScrollbar>
                        </Fragment>

                        <Fragment>
                            <div>
                                <div className="lineDiv"></div>
                                <p className="settingsTitleMenu">Settings</p>
                            </div>
                            <PerfectScrollbar
                                className="main-menu-content"
                                options={{ wheelPropagation: false }}
                                onScrollY={(container) => scrollMenu(container)}
                            >
                                <ul
                                    className="navigation navigation-main"
                                    style={{ height: "100%" }}
                                >
                                    <VerticalNavMenuItems
                                        items={[
                                            {
                                                id: "settings",
                                                title: "Main Settings",
                                                icon: (
                                                    <img
                                                        src={settings}
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/settings",
                                            },
                                            {
                                                id: "replayTour",
                                                title: "Replay Tour",
                                                icon: (
                                                    <img
                                                        src={refresh}
                                                        style={{
                                                            marginRight: "15px",
                                                            width: "25px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/",
                                            },
                                            {
                                                id: "logout",
                                                title: "Logout",
                                                icon: (
                                                    <img
                                                        src={logout}
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/",
                                            },
                                        ]}
                                        menuData={[
                                            {
                                                id: "mainSettings",
                                                title: "Main Settings",
                                                icon: (
                                                    <img
                                                        src={settings}
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/",
                                            },
                                            {
                                                id: "notifications",
                                                title: "Notifications",
                                                icon: (
                                                    <img
                                                        src={notifications}
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/", //notifications
                                            },

                                            {
                                                id: "logout",
                                                title: "Logout",
                                                icon: (
                                                    <img
                                                        src={logout}
                                                        style={{
                                                            marginRight: "15px",
                                                        }}
                                                        alt="dff"
                                                    />
                                                ),
                                                navLink: "/",
                                            },
                                        ]}
                                        menuHover={menuHover}
                                        isInvate={isInvate}
                                        groupOpen={groupOpen}
                                        activeItem={activeItem}
                                        groupActive={groupActive}
                                        currentActiveGroup={currentActiveGroup}
                                        routerProps={routerProps}
                                        setGroupOpen={setGroupOpen}
                                        menuCollapsed={menuCollapsed}
                                        setActiveItem={setActiveItem}
                                        setGroupActive={setGroupActive}
                                        setCurrentActiveGroup={
                                            setCurrentActiveGroup
                                        }
                                        currentActiveItem={currentActiveItem}
                                    />
                                </ul>
                            </PerfectScrollbar>
                        </Fragment>
                    </div>
                )}
            </div>
        </Fragment>
    ) : (
        ""
    );
};

export default Sidebar;
